import { render, staticRenderFns } from "./paperBody.vue?vue&type=template&id=6d56971b&scoped=true"
import script from "./paperBody.vue?vue&type=script&lang=js"
export * from "./paperBody.vue?vue&type=script&lang=js"
import style0 from "./paperBody.vue?vue&type=style&index=0&id=6d56971b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_n3acbem2au4l2e3t4qvos3rwwq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d56971b",
  null
  
)

export default component.exports